import { render, staticRenderFns } from "./UnitInputGroup2P.vue?vue&type=template&id=26767e2c&scoped=true"
import script from "./UnitInputGroup2P.vue?vue&type=script&lang=js"
export * from "./UnitInputGroup2P.vue?vue&type=script&lang=js"
import style0 from "./UnitInputGroup2P.vue?vue&type=style&index=0&id=26767e2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26767e2c",
  null
  
)

export default component.exports